export const CALL_STATUS = {
	IDLE: "idle",
	PENDING: "pending",
	SUCCESS: "success",
	ERROR: "error",
};
